import { /*defineStyle, defineStyleConfig,*/ extendTheme } from "@chakra-ui/react";
import { ChakraTheme } from "@chakra-ui/react";
import { theme as coreTheme } from "am-tax-fe-core";

const themeOverrides: Partial<ChakraTheme> = {
    components: {},
};

export const theme = extendTheme(coreTheme, themeOverrides);
